<template>
  <div>
    <div class="card card-custom mb-5">
      <div class="card-header h-auto py-2">
        <div class="card-title">
          <h3 class="card-label">
            ATG Client Id: {{ currentItem.ATGClientId }}
          </h3>
        </div>
        <div class="card-toolbar">
          <!--          <button-->
          <!--              class="align-self-start btn btn-sm btn-secondary mx-1"-->
          <!--              type="button"-->
          <!--              @click="downloadpdf"-->
          <!--          >-->
          <!--            Download PDF-->
          <!--          </button>-->
        </div>
      </div>
      <div class="card-body py-4">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Series Type:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.SeriesType
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Status:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.Status
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Range:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">
                  {{ currentItem.RangeStart | numFormat("000000") }} -
                  {{ currentItem.RangeEnd | numFormat("000000") }}</span
                >
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Current:</label>
              <div class="col-8 ">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.CurrentCount | numFormat("000000")
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4  col-form-label">Remaining:</label>
              <div class="col-8 ">
                <b-progress
                  :value="currentItem.RangeEnd - currentItem.CurrentCount"
                  :max="currentItem.RangeEnd"
                  show-value
                ></b-progress>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group row my-1">
              <label class="col-4 col-form-label">LastATGCheck:</label>
              <div class="col-8">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.LastATGCheck | moment("LLLL")
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4 col-form-label">Created:</label>
              <div class="col-8">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.CreatedDateTime | moment("LLLL")
                }}</span>
              </div>
            </div>
            <div class="form-group row my-1">
              <label class="col-4 col-form-label">Created By:</label>
              <div class="col-8">
                <span class="form-control-plaintext font-weight-bolder">{{
                  currentItem.CreatedBy
                }}</span>
              </div>
            </div>
          </div>
          <div class="col-12"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import numeral from "numeral";
import numFormat from "vue-filter-number-format";

Vue.use(require("vue-moment"));
Vue.filter("numFormat", numFormat(numeral));

Vue.use(require("vue-moment"));
export default {
  components: {},
  props: ["propdata"],
  data() {
    return {
      isBusy: false,
      tabIndex: 0,
      currentItem: {},
      files: []
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
      this.setBreadcrumbs(
        this.propdata.ATGClientId + " (" + this.propdata.SeriesType + ")"
      );
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreciept"
        },
        {
          title: "ATG",
          route: "/easyreceipt/atg"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    getData() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = { TransactionId: self.propdata.ATGId };
        ApiService.get("atg/getbyid", param)
          .then(({ data }) => {
            this.$gtag.event("atg_getbyid");
            self.isBusy = false;
            if (data) {
              self.currentItem = data;
            }
            resolve(data);
          })
          .catch(({ response }) => {
            self.isBusy = false;
            reject(response);
          });
      });
    }
  },
  watch: {}
};
</script>

<style>
.col-form-label,
.form-control-plaintext {
  padding-top: 0px;
  padding-bottom: 0px;
}

.card.card-custom > .card-header {
  min-height: 50px;
}
</style>
